import React, { useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
  Box,
  Chip,
  Divider,
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VillaIcon from "@mui/icons-material/Villa";
import TimerIcon from "@mui/icons-material/Timer";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CommentIcon from "@mui/icons-material/Comment";
import CallIcon from "@mui/icons-material/Call";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { AGENT_INCOMMING_CALL } from "../../../constants";

function ConnectedCallTable({
  incomingConnected,
  filters,
  setFilters,
  connectedFilters,
  setConnectedFilters,
  setLoading,
}) {
  const calls = incomingConnected?.connectedCalls || [];
  const totalRecords = incomingConnected?.pagination?.totalRecords || 0;
  const currentPage =
    incomingConnected?.pagination?.page || connectedFilters.page;
  const pageSize =
    incomingConnected?.pagination?.pageSize || connectedFilters.pageSize;

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setConnectedFilters((prev) => ({ ...prev, page: newPage + 1 })); // API expects 1-based
  };

  const handleChangeRowsPerPage = (event) => {
    setConnectedFilters((prev) => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      page: 1,
    }));
  };

  const empDetails = JSON.parse(localStorage.getItem("userData"));
  // console.log("incomingConnected:::::::::::::::::",incomingConnected)
  const location = useLocation();
  const navigate = useNavigate();
  // const prevFilters = JSON.parse(localStorage.getItem("agentFilters"));
  // const { prevFilters } = location.state || {}; // Access prevFilters from state
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalCount, setTotalCount] = useState(0);
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  // Filter states

  // this mmobile filter is for filtering connected and missed calls

  const [mobileFilter, setMobileFilter] = useState("");
  //  const [stateFilter, setStateFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const { agentName, agentNo } = useParams();

  //  const [callData, setCallData] = useState(dummyCallData);

  //  const isInitialLoad = useRef(true);

  // State options for dropdown (you can modify this list as needed)
  const stateOptions = [
    "AP",
    "OD",
    "TN",
    "RJ",
    "GJ",
    "HR",
    "PN",
    "KT",
    "WB",
    "CG",
  ];

  // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const handleCallIconClick = (row) => {
    navigate("/dashboard", {
      state: {
        mobNo: row.callerNumber,
        lotNum: row.callerNumber,
        missedCallId: row.id,
      },
    });
  };

  const IconCell = ({ row }) => (
    <Button
      variant="contained"
      size="small"
      startIcon={<CallIcon />}
      onClick={() => handleCallIconClick(row)}
      sx={{
        minWidth: "auto",
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: 1,
        "&:hover": {
          boxShadow: 2,
          transform: "translateY(-1px)",
        },
        transition: "all 0.2s ease",
      }}
    >
      Call
    </Button>
  );

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  const getDurationColor = (duration) => {
    if (!duration || duration === "-") return "default";
    const durationNum = parseFloat(duration);
    if (durationNum < 2) return "error";
    if (durationNum < 5) return "warning";
    return "success";
  };

  const InfoItem = ({ icon, label, value }) => (
    <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: 140,
          color: "text.secondary",
          fontSize: "0.875rem",
          fontWeight: 500,
        }}
      >
        {icon}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
          {label}:
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ ml: 1, fontWeight: 400 }}>
        {value || "-"}
      </Typography>
    </Box>
  );
function formatDateTimeCompact(isoString) {
  // Parse using Date constructor
  const date = new Date(isoString);
  
  if (isNaN(date)) return "-"; // fallback if invalid date

  // Get date parts
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = String(date.getUTCFullYear()).slice(-2); // last 2 digits

  // Get time parts
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // convert 0 to 12

  return `${day}-${month}-${year}, ${hours}:${minutes}${ampm}`;
}



  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        {/* Filter Section */}
        <Box
          sx={{
            p: 2,
            backgroundColor: "grey.50",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: showFilters ? 2 : 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center", fontWeight: 600 }}
            >
              <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
              Connected Calls
            </Typography>
            {/* <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(!showFilters)}
              size="small"
              sx={{ textTransform: 'none' }}
            >
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button> */}
          </Box>

          {/* <Collapse in={showFilters}> */}
          {/* <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <TextField
                label="Mobile Number"
                value={mobileFilter}
                onChange={handleMobileFilterChange}
                placeholder="Enter mobile number"
                size="small"
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
                sx={{ minWidth: 200 }}
              />

              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={stateFilter}
                  onChange={handleStateFilterChange}
                  label="State"
                >
                  <MenuItem value="">
                    <em>All States</em>
                  </MenuItem>
                  {stateOptions.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {(mobileFilter || stateFilter) && (
                <Button
                  variant="outlined"
                  startIcon={<ClearIcon />}
                  onClick={handleClearFilters}
                  size="small"
                  color="error"
                  sx={{ textTransform: 'none' }}
                >
                  Clear Filters
                </Button>
              )}
            </Box> */}

          {/* Active filters display */}
          {/* {(mobileFilter || stateFilter) && (
              <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', mr: 1 }}>
                  Active Filters:
                </Typography>
                {mobileFilter && (
                  <Chip
                    label={`Mobile: ${mobileFilter}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                    onDelete={() => setMobileFilter("")}
                  />
                )}
                {stateFilter && (
                  <Chip
                    label={`State: ${stateFilter}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                    onDelete={() => setStateFilter("")}
                  />
                )}
              </Box>
            )} */}
          {/* </Collapse> */}
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="connected calls table"
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "primary.main",
                  "& .MuiTableCell-head": {
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                  },
                }}
              >
                <TableCell width={60} sx={{ textAlign: "center" }} />
                {/* <TableCell width={60} sx={{ textAlign: "center", padding: 2 }}>
                  S.No
                </TableCell> */}
                {/* <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PhoneIcon sx={{ mr: 1, fontSize: 18 }} />
                    Call Type
                  </Box>
                </TableCell> */}
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Customer Name
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PhoneIcon sx={{ mr: 1, fontSize: 18 }} />
                    Mobile Number
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <VillaIcon sx={{ mr: 1, fontSize: 18 }} />
                    Region Name
                  </Box>
                </TableCell>

                <TableCell width={140} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MoreHorizIcon sx={{ mr: 1, fontSize: 18 }} />
                    Category
                  </Box>
                </TableCell>

                <TableCell width={140} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MoreHorizIcon sx={{ mr: 1, fontSize: 18 }} />
                    Time
                  </Box>
                </TableCell>

                <TableCell width={140} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MoreHorizIcon sx={{ mr: 1, fontSize: 18 }} />
                    Sub-Category
                  </Box>
                </TableCell>
                {/* <TableCell
                  width={140}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <TimerIcon sx={{ mr: 1, fontSize: 18 }} />
                    Action
                  </Box>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(calls) && calls.length > 0 ? (
                calls.map((row, rowIndex) => (
                  <React.Fragment key={rowIndex}>
                    <TableRow
                      sx={{
                        "&:hover": { backgroundColor: "action.hover" },
                        backgroundColor:
                          rowIndex % 2 === 0 ? "grey.50" : "white",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <TableCell sx={{ padding: 1 }}>
                        <IconButton
                          onClick={() => handleRowToggle(rowIndex)}
                          sx={{
                            padding: 1,
                            transition: "transform 0.2s ease",
                            "&:hover": {
                              backgroundColor: "primary.main",
                              color: "white",
                              transform: "scale(1.1)",
                            },
                          }}
                        >
                          {openRows.includes(rowIndex) ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        <Chip
                          // label={page * rowsPerPage + rowIndex + 1}
                          label={(currentPage - 1) * pageSize + (rowIndex + 1)}
                          size="small"
                          variant="outlined"
                          color="primary"
                        />
                      </TableCell> */}

                      {/* <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {row.leadDetail?.call_type || "-"}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {row.leadDetail?.CustomerName || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          // fontFamily: "monospace",
                        }}
                      >
                        {row.leadDetail?.MobileNo || row.caller_number || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.region_name || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.category || "-"}
                      </TableCell>
                          <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {formatDateTimeCompact(row.call_start_time) || "-"}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.sub_category || "-"}
                      </TableCell>
                    </TableRow>

                    {/* Expandable Row */}
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
                      >
                        <Collapse
                          in={openRows.includes(rowIndex)}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ margin: 2 }}>
                            <Card elevation={1} sx={{ borderRadius: 2 }}>
                              <CardContent sx={{ p: 3 }}>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    mb: 2,
                                    color: "primary.main",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <PersonIcon sx={{ mr: 1 }} />
                                  Customer Details
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                <Grid container spacing={3}>
                                  <Grid item xs={12} md={6}>
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Region"
                                      value={row.leadDetail?.region_name}
                                    />
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="State"
                                      value={row.leadDetail?.state_name}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Postal Code"
                                      value={row.leadDetail?.pincode}
                                    />
                                    <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Agent Remark"
                                      value={row.leadDetail?.agent_remark}
                                    />
                                  </Grid>
                                </Grid>
                                {/* 
                    <Typography
                      variant="h6"
                      sx={{
                        mt: 3,
                        mb: 2,
                        color: "primary.main",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <PersonIcon sx={{ mr: 1 }} />
                      Agent Details
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <InfoItem label="Agent Name" value={row.agent?.EmployeeName} />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InfoItem label="Agent Phone" value={row.agent?.EmployeePhone} />
                      </Grid>
                    </Grid> */}

                                {/* <Typography
                      variant="h6"
                      sx={{
                        mt: 3,
                        mb: 2,
                        color: "primary.main",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <CommentIcon sx={{ mr: 1 }} />
                      Remarks
                    </Typography> */}
                                <Typography
                                  variant="h6"
                                  sx={{
                                    mt: 3,
                                    mb: 2,
                                    color: "primary.main",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <CommentIcon sx={{ mr: 1 }} />
                                  Remarks
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                {row.leadDetail?.agent_remark ? (
                                  <Box
                                    sx={{
                                      p: 2,
                                      backgroundColor: "grey.50",
                                      borderRadius: 2,
                                      border: "1px solid",
                                      borderColor: "grey.300",
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{ color: "text.primary" }}
                                    >
                                      {row.leadDetail.agent_remark}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      textAlign: "center",
                                      py: 3,
                                      color: "text.secondary",
                                      backgroundColor: "grey.50",
                                      borderRadius: 2,
                                      border: "1px dashed",
                                      borderColor: "grey.300",
                                    }}
                                  >
                                    <CommentIcon
                                      sx={{ fontSize: 48, mb: 1, opacity: 0.5 }}
                                    />
                                    <Typography variant="body1">
                                      No remarks available
                                    </Typography>
                                  </Box>
                                )}

                                <Divider sx={{ mb: 2 }} />

                                {/* <Box
                                  sx={{
                                    textAlign: "center",
                                    py: 3,
                                    color: "text.secondary",
                                    backgroundColor: "grey.50",
                                    borderRadius: 2,
                                    border: "1px dashed",
                                    borderColor: "grey.300",
                                  }}
                                >
                                  <CommentIcon
                                    sx={{ fontSize: 48, mb: 1, opacity: 0.5 }}
                                  />
                                  <Typography variant="body1">
                                    No remarks available
                                  </Typography>
                                </Box> */}
                              </CardContent>
                            </Card>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
                    <Box
                      sx={{
                        display: "flex",
                        paddingLeft:"350px",
                        flexDirection: "column",
                        alignItems: "center",
                        color: "text.secondary",
                      }}
                    >
                      <PhoneIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
                      <Typography variant="h6" sx={{ mb: 1 }}>
                        No Call Details Available
                      </Typography>
                      <Typography variant="body2">
                        There are no connected calls to display for the selected
                        period.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalRecords} // total unique calls
          page={currentPage - 1} // convert to 0-based
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: "1px solid",
            borderColor: "divider",
            backgroundColor: "grey.50",
          }}
        />
      </Paper>
    </>
  );
}

export default ConnectedCallTable;
